import moment from 'moment'
import cn from 'classnames'

import styles from './plain-weekday-selector.module.scss'

type Props = {
  className?: string
  currentIndex?: number
  onChange?: (index: number) => void
}

export const PlainWeekdaySelector = ({ className, currentIndex = -1, onChange }: Props) => {
  const weekdays = moment.weekdays(true)
  return (
    <div className={cn(styles.root, className)}>
      {weekdays.map((day, index) => (
        <label className={styles.labelWeekday} key={day}>
          <input
            type="radio"
            id={`weekdays-${index}`}
            name="weekdays"
            value={index - 1}
            checked={currentIndex === index}
            onChange={() => onChange?.(index)}
          />
          <span className={styles.weekdayVisual}>{day}</span>
        </label>
      ))}
    </div>
  )
}
